import TrackDetails from './track-details';
export default TrackDetails;